import classed from "./classed";
export default function () {
    classed(this._container, 'opened-nav', false);
    return this;
}